import Request from '@utils/request'

export default async function auth({ next }) {
  Request.setCatchError(403, true)
  return next()
  // await store.dispatch('user/getUserProfile')
  // const role = store.getters['user/role']
  // console.error('role', role)
  // const roles = to.meta.roles || ['admin', 'employee']

  // if (roles.includes(role)) {
  //   return next()
  // } else {
  //   return next({
  //     name: 'error-403'
  //   })
  // }
}
